export enum VendaDataTipo {
    DataGeracao = 1,
    DataOrcamento = 2,
    DataPedido = 3,
    DataVenda = 4,
    DataBonificacao = 5,
    Validade = 6,
    Faturamento = 7,
    EntregaInicial = 8,
    EntregaFinal = 9,
    UltimaAlteracao = 10,
}

export function vendaTipoDataToString(tipo: VendaDataTipo): string {
    switch (tipo) {
        case VendaDataTipo.DataGeracao:
            return 'Data de geração';
        case VendaDataTipo.DataOrcamento:
            return 'Data do orçamento';
        case VendaDataTipo.DataPedido:
            return 'Data do pedido';
        case VendaDataTipo.DataVenda:
            return 'Data da venda';
        case VendaDataTipo.DataBonificacao:
            return 'Data da bonificação';
        case VendaDataTipo.Validade:
            return 'Validade';
        case VendaDataTipo.Faturamento:
            return 'Faturamento';
        case VendaDataTipo.EntregaInicial:
            return 'Entrega inicial';
        case VendaDataTipo.EntregaFinal:
            return 'Entrega final';
        case VendaDataTipo.UltimaAlteracao:
            return 'Última alteração';
        default: {
            tipo satisfies never;
            return 'Tipo desconhecido';
        }
    }
}
